// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3Xy-M","Open":"SideDrawer_Open__3A-d0","Close":"SideDrawer_Close__1Nl6X","Logo":"SideDrawer_Logo__3ioPn"};